import { render, staticRenderFns } from "./AppNavigationHeader.vue?vue&type=template&id=66a813e8&"
import script from "./AppNavigationHeader.vue?vue&type=script&lang=js&"
export * from "./AppNavigationHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/krankerl.FFR503Cp8cB3/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66a813e8')) {
      api.createRecord('66a813e8', component.options)
    } else {
      api.reload('66a813e8', component.options)
    }
    module.hot.accept("./AppNavigationHeader.vue?vue&type=template&id=66a813e8&", function () {
      api.rerender('66a813e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppNavigation/AppNavigationHeader.vue"
export default component.exports